import { ReprocessRunsPage } from "@/features/ai-reprocess/ReprocessRunsPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

export function ReprocessRunsRoute() {
  const { token, profile } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;
  // Mesmo papel que a API exige pra reprocessar e pra ler as execuções.
  if (!hasRoleAtLeast(profile, "administrator")) {
    return <ApiState kind="error">O reprocessamento por IA é de Administrador ou acima.</ApiState>;
  }
  return (
    <ReprocessRunsPage
      token={token}
      runHref={runId => `/empresas/${company.id}/reprocessamentos/${runId}`}
    />
  );
}
